'use strict';

var chunk3CUP7X6U_js = require('./chunk-3CUP7X6U.js');
var p = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var p__default = /*#__PURE__*/_interopDefault(p);

function a({fill:o="#0F0F10",onClick:f,size:i}){return p__default.default.createElement(chunk3CUP7X6U_js.a,{size:i||"16px",fill:o,onClick:f,viewBox:"0 0 12 12"},p__default.default.createElement("path",{d:"M9.64 9.11a.375.375 0 11-.53.53L6 6.53 2.89 9.64a.375.375 0 11-.53-.53L5.47 6 2.36 2.89a.375.375 0 01.53-.53L6 5.47l3.11-3.11a.375.375 0 11.53.53L6.53 6l3.11 3.11z",fill:o||"#fff"}))}var e=a;

exports.a = e;
